import { LatLon } from '@/services/bimoboxApiService/types'

export const openGoogleMaps = (location: LatLon): void => {
  const queryparams = `${location.lat},${location.lon}`
  window.open(
    `https://www.google.com/maps/search/?api=1&query=${queryparams}`,
    '_blank'
  )
}
